import React from "react";
import ToothPositionView from "./toothPositionView";

const JobSheet = ({ jobSheetData, isVisible, toothGridData }) => {
  return (
    <div
      id="job-sheet"
      className={`border-gray border px-12 pb-4 pt-12 m-auto rounded-4xl relative ${
        !isVisible ? "hidden" : ""
      }`}
      style={{
        width: "794px", // A4 width (portrait mode)
        minHeight: "auto", // A4 height (portrait mode)
        backgroundColor: "white", // Ensures consistent background
        overflow: "hidden", // Prevents overflow issues
        pageBreakInside: "avoid", // Avoids page breaks inside
      }}
    >
      <div className="flex items-center justify-end gap-2 absolute right-8 top-8 text-gray-500">
        <p className="text-4xl xl:text-4xl 4xl:text-4xl text-gray-600 font-interRegular mb-0">
          {jobSheetData?.dentistName}
        </p>{" "}
        |
        <p className="text-4xl xl:text-4xl 4xl:text-4xl text-gray-600 font-interRegular mb-0">
          {jobSheetData?.patientName}
        </p>
      </div>
      <div className="2xl:w-3/4 pt-4">
        <p className="text-4xl xl:text-4xl 4xl:text-4xl text-gray-700 font-interBold pt-2 mb-2">
          {jobSheetData?.workTypeDescription}
        </p>
        <div>
          <ToothPositionView toothGridData={toothGridData} />
        </div>
        <hr className="border-gray my-6" />
        <p className="text-4xl xl:text-4xl 4xl:text-4xl text-gray-700 font-interRegular mb-2">
          Bitte Beachten :
        </p>
        <p className="text-4xl xl:text-4xl 4xl:text-4xl text-gray-700 font-interBold">
          {jobSheetData?.standard_Notes || ""}
        </p>

        <hr className="border-gray my-6" />
        <p className="text-4xl xl:text-4xl 4xl:text-4xl text-gray-700 font-interRegular mb-2">
          Individuelle Notiz :
        </p>
        <p className="text-4xl xl:text-4xl 4xl:text-4xl text-gray-700 font-interBold pb-5">
          {jobSheetData?.individual_Notes || ""}
        </p>
      </div>
    </div>
  );
};

export default JobSheet;
